import { ApiResponse } from "../../../model/common/apiResponse"; 
import { axiosService, ServiceEndPoint } from "../../../Services/common/Axios.service";



const SERVICE_URL = ServiceEndPoint.account_service; 

export async function createItem(payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.post(`${SERVICE_URL}items`, payload);
  return response.data;
}
export async function getItemById(id?:string): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${SERVICE_URL}items/${id}`);
    return response.data;
}

export async function updateItem(id:string,payload:any): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}items/${id}`,payload);
  return response.data;
}
export async function deleteItem(id:number): Promise<ApiResponse<any>>{
  const response = await axiosService.delete(`${SERVICE_URL}items/${id}`);
  return response.data;
}